import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'STUDENT_CLASSROOMS_GET_ALL',
  GET_ALL_SUCCESS: 'STUDENT_CLASSROOMS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'STUDENT_CLASSROOMS_GET_ALL_FAILURE',
  PATCH: 'CLASSROOMS_PATCH',
  PATCH_SUCCESS: 'CLASSROOMS_PATCH_SUCCESS',
  PATCH_FAILURE: 'CLASSROOMS_PATCH_FAILURE',
};

export const patch = actions.patch(
  classroomId => `${BASE_URL}/student-classrooms/${classroomId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
